<template>
    <section class="content">
      <!-- <keep-alive> -->
      <div id="overlay" v-if="loading">
        <div class="spinner"></div>
        <br />
        <h4>Loading...</h4>
      </div>
      <div>
        <div class="box box-info">
              <DataTable :value="salesUnreceivedLists" :paginator="true" ref="po" :rows="100" :filters="filters" editMode="cell"
                :rowsPerPageOptions="[100, 500, 1000]" class="p-datatable-responsive p-datatable-gridlines" data-key="id"
                :selection.sync="selectedProduct1" selectionMode="single">
                <Column header="S.N">
                  <template #body="sl">
                    {{ sl.index + 1 }}
                  </template>
                </Column>
                <Column header="Miti" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDateNepali"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDateNepali']" />
                  </template>
                </Column>
                <Column header="Date" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDate"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDate']" />
                  </template>
                </Column>
                <Column header="Bill No" :sortable="true" field="billNo" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['billNo']" />
                  </template>
                </Column>
                <Column header="Customer" :sortable="true" field="accountName" filterMatchMode="contains">
                  <template #body="slotProps">
                    {{ slotProps.data.accountMaster.name }}
                  </template>
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['accountName']" />
                  </template>
                  <template #footer>
                    Total:
                  </template>
                </Column>
                <Column header="Address" :sortable="true" field="address" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['address']" />
                  </template>
                </Column>
                <Column header="Contact No" :sortable="true" field="contactNumber" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']" />
                  </template>
                </Column>
                <Column header="Remarks"  >
                  <template #body="slotProps">
                    <Button class="p-button-raised p-button-warning" v-tooltip.top="'View Remarks'"
                      @click="showMessageDialog(slotProps.data)" ><span class="pi pi-envelope"></span></Button>
                  </template>
                </Column>
                <Column header="Transportation Details"  >
                  <template #body="slotProps">
                    
                    <Button  class="p-button-raised p-button-warning" v-tooltip.top="'View Transport Details'"
                      @click="showTransportationDialog(slotProps.data)" ><span class="fa fa-truck"></span></Button>
                  </template>
                </Column>
                <Column header="Store" :sortable="true" field="warehouse.name" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['warehouse.name']" />
                  </template>
                </Column>
            
                <Column header="Total" bodyStyle="text-align: right" field="totalBillAmount" :sortable="true"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['totalBillAmount']" />
                  </template>
                  <template #footer >
                    {{ totalSumBillAmount.toFixed(2) }}
                  </template>
                </Column>
                <Column header="Received Status" bodyStyle="text-align: right" field="goodsReceivedStatus" :sortable="true"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['goodsReceivedStatus']"/>
                </template>
                <template #editor="slotProps">
                  <Dropdown v-model="slotProps.data['goodsReceivedStatus']" :options="statusesPay"
                            @change="updatePaymentStatus(slotProps.data, 'drop')"
                            optionLabel="label" optionValue="value" placeholder="Select a Status">
                    <template #option="slotProps">
                      <span>{{ slotProps.option.label }}</span>
                    </template>
                  </Dropdown>
                </template>
                <template #body="slotProps">
                  {{ getReceivedStatusLabel(slotProps.data.goodsReceivedStatus) }}
                </template>
              </Column>
              <Column header="Org Name" :sortable="true" field="organisationName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['organisationName']"/>
                </template>
              </Column>
                <Column header="Action" >
                  <template #body="slotProps">
                    <Button  class="p-button-raised p-button-warning" v-tooltip.top="'View Details'"
                      @click="viewPIVDetail(slotProps.data)" ><span class="fa fa-eye"></span></Button>
                  </template>
                </Column>
                <template #empty>No record found</template>
              </DataTable>
        </div>
        <Dialogs header="Remarks" :visible.sync="receivedMessageDialog"
                 :style="{width: '50vw'}" :modal="true" :closable=true :contentStyle="{'overflow': 'visible'}">
          <div class="col-md-12">
            <label for="reason" class="col-md-4 control-label">Remarks</label>
            <div class="form-group col-md-8">
              <textarea class="form-control" rows="5" v-model="receivedMessgae"></textarea>
              <small style="color: #e74c3c; font-style: italic; display: block; margin-top: 4px;">
                For date in remarks, enter in format like <strong>2082-04-29</strong>, not 2082/04/29
              </small>
            </div>
          </div>
          <template #footer>
            <Button class="p-button-raised p-button-success" @click.prevent="updatePaymentStatus(null, 'ramarks')"
                    label="Update"/>
            <Button class="p-button-raised p-button-danger" @click="cancelMessage" label="Cancel"/>
          </template>
        </Dialogs>
        <Dialogs header="Transportation Details" :visible.sync="transportationDialog"
               :style="{width: '50vw'}" :modal="true" :closable=true :contentStyle="{'overflow': 'visible'}">
               <div class="p-fluid p-formgrid p-grid">
                 <div class="p-field p-col-12 p-md-4">
                  <label for="subHead">Name<span style="color:red"></span></label>
                  <InputText v-model.trim="this.transportationDetails.name"  id="subHead"/>
                </div>
                <!-- <div class="p-field p-col-12 p-md-6"></div> -->
                  <div class="p-field p-col-12 p-md-4">
                    <label for="costing">Route</label>
                    <!-- <div class="p-field p-col-12 p-md-6"> -->
                    <InputText v-model.trim="this.transportationDetails.route"  id="subHead"/>
                    <!-- </div> -->
                </div>

                <div class="p-field p-col-12 p-md-4">
                    <label for="costing">Address</label>
                    <!-- <div class="p-field p-col-12 p-md-6"> -->
                    <InputText v-model.trim="this.transportationDetails.address"  id="subHead"/>
                    <!-- </div> -->
                </div>
                 <div class="p-field p-col-12 p-md-4">
                   <label for="vat">Contact Name</label>
                   <!-- <div class="p-field p-col-12 p-md-6"> -->
                    <InputText v-model.trim="this.transportationDetails.contactPerson"  id="subHead"/>
                  <!-- </div> -->
                 </div>
                 <div class="p-field p-col-12 p-md-4">
                   <label for="head">From Contact Number <span style="color:red"></span></label>
                   <InputText v-model.trim="this.transportationDetails.contactNumberFrom"  id="subHead"/>
                 </div>
    
                 <div class="p-field p-col-12 p-md-4">
                   <label for="head">To Contact Number</label>
                   <!-- <InputText v-model.trim="this.transportationDetails.contactNumberTo"  id="subHead"/> -->
                   <textarea type="text" rows="2" class="form-control" v-model="this.transportationDetails.contactNumberTo"/>
                   <!-- <Dropdown
                      v-model="creditAccountId"
                      :options="accountMasterList"
                      optionLabel="name" :filter="true"
                      placeholder="Select Credit Account"
                      :showClear="true"
                    /> -->
                 </div>
              </div>
            <template #footer>
                <!-- <Button class="p-button-raised" @click.prevent="addTransportationDetails" :label="!this.editing?'Add':'Update'"/>
                <Button class="p-button-raised p-button-info" @click.prevent="addAndNewExtraExpenses" v-if="!editing"
                 label="Add & New"/> -->
              <Button  class="p-button-raised p-button-danger" @click.prevent="closelTransportation" label="Close"/>
            </template>
          </Dialogs>
      </div>
      <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport" />
    </section>
  </template>
  <script>
  import DatePicker from 'vue2-datepicker'
  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'
  import Dialog from '../../layout/dialog'
  import globalKey from '../../../store/globalKey'
  import axios from 'axios'
  // import $ from 'jquery'
  import InputText from 'primevue/inputtext'
  import Button from 'primevue/button'
  import InputMask from 'primevue/inputmask'
  import Dropdown from 'primevue/dropdown'
  import Dialogs from 'primevue/dialog'
  import Textarea from 'primevue/textarea'
  
  export default {
    name: 'salesInvoiceUnpaidReport',
    props: ['status'],
    data() {
      return {
        id: null,
        fromDate: null,
        transportationDetails: '',
        toDate: null,
        loading: false,
        receivedMessgae: '',
        dialogShow: false,
        transportationDialog: false,
        receivedMessageDialog: false,
        selectedProduct1: null,
        columnList: '',
        filters: {},
        englishDateEnabled: true,
        enableEdit: false,
        enableDelete: false,
        totalSubAmount: 0,
        totalNonTaxableAmount: 0,
        totalTaxableAmount: 0,
        totalVatAmount: 0,
        totalSumBillAmount: 0,
        totalDiscountAmount: 0,
        goodsReceivedStatus: '',
        statusesPay: [{label: 'Processing', value: 'Processing'}, {label: 'Completed', value: 'Completed'}, {label: 'OnTheWay', value: 'OnTheWay'}],
        payMethod: [{label: 'Cash', value: 'CASH'}, {label: 'Esewa', value: 'ESEWA'}, {label: 'Prabhu Bank', value: 'PRABHU'}, {label: 'Nic Bank', value: 'NIC'}]
      }
    },
    computed: {
      salesUnreceivedLists() {
        return this.$store.state.sales.salesUnreceivedLists
      }
    },
    mounted() {
      if (this.status !== undefined) {
        this.$toast.add({ severity: 'success', summary: '', detail: this.status.message, life: 3000 })
      }
      this.salesInvoiceUnpaidList()
      this.columnNames()
    },
    methods: {
      async searchUnpaidInvoice() {
        this.loading = !this.loading
        let resp = await this.$store.dispatch('loadSalesInvoiceUnReceivedLists')
        this.loading = false
        if (resp.data.data.length <= 0) {
          this.$toast.add({ severity: 'error', summary: '', detail: resp.data.message, life: 3000 })
        } else {
          this.$toast.add({ severity: 'success', summary: '', detail: resp.data.message, life: 3000 })
        }
        this.totalBalance()
      },
      async viewPIVDetail(data) {
        let PIHdata = {
          id: data.id,
          warehouse: data.warehouse,
          account: data.accountMaster,
          salesDate: data.purchaseSalesDateNepali,
          billNo: data.billNo,
          reportType: data.reportType,
          referenceNumber: data.referenceNumber,
          subTotalAmount: data.subTotalAmount,
          nonTaxableAmount: data.nonTaxableAmount,
          taxableAmount: data.taxableAmount,
          vatAmount: data.vatAmount,
          totalBillAmount: data.totalBillAmount,
          vatTypeEnum: data.vatTypeEnum,
          exciseChargeAmount: data.exciseChargeAmount,
          discountAmt: data.discount,
          remarks: data.remarks
        }
        if (data.purchaseType !== 'dairy') {
          this.$router.push({ name: 'sales Detail Report', params: { salesHeaderObj: PIHdata } })
        } else {
          this.$router.push({ name: 'sales Detail Dairy Report', params: { purchaseHeaderObj: PIHdata } })
        }
      },
      exportCSV() {
        let data = {
          fromDate: this.fromDate,
          toDate: this.toDate,
          columnList: this.columnList
        }
        axios({
          url: globalKey + '/fileDownload/excelReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/salesInvoice' + '/' + this.$store.getters.fyId + '/' + data.columnList,
          method: 'get',
          headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]), { type: response.data.type })
          const link = document.createElement('a')
          const contentDisposition = response.headers['content-disposition']
          let fileName = 'salesInvoice.xlsx'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1]
            }
          }
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        })
      },
      async salesInvoiceUnpaidList() {
        await this.$store.dispatch('loadSalesInvoiceUnReceivedLists')
        this.totalBalance()
      },
      exportToPdf(SOHeaderId) {
        axios({
          url: globalKey + '/fileDownload/printSalesBill/' + SOHeaderId + '/salesInvoice' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
          method: 'get',
          headers: { 'Accept': 'application/pdf', 'Authorization': localStorage.token },
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]), { type: response.data.type })
          const link = document.createElement('a')
          const contentDisposition = response.headers['Content-Disposition']
          let fileName = 'salesInvoice.pdf'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1]
            }
          }
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        })
      },
      async updatePaymentStatus(data, type) {
        if (type === 'drop') {
          this.goodsReceivedStatus = data.goodsReceivedStatus
          this.id = data.id
          this.receivedMessgae = data.receivedRemarks
        }
        if (this.receivedMessgae === undefined) {
          this.receivedMessgae = '-'
        }
        let payment = {
          id: this.id,
          goodsReceivedStatus: this.goodsReceivedStatus,
          receivedRemarks: this.receivedMessgae
          // status: data.paymentStatus,
          // method: data.paymentMethod
        }
        let response = await this.$store.dispatch('goodsReceivedStatusUpdate', payment)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({
            severity: 'success',
            summary: '',
            detail: 'Updated' + response.data.message,
            life: 3000
          })
        }
        this.receivedMessageDialog = false
      },
      getReceivedStatusLabel(payStatus) {
        switch (payStatus) {
          case 'Processing':
            return 'Processing'
          case 'Completed':
            return 'Completed'
          case 'OnTheWay':
            return 'OnTheWay'

          default:
            return 'NA'
        }
      },
      columnNames() {
        for (let i = 0; i < this.$refs.po.columns.length; i++) {
          this.columnList += this.$refs.po.columns[i].header + ','
        }
      },
      checkEnableEdit() {
        if (this.$store.getters.modules.includes(',5.08')) {
          this.enableEdit = true
        }
      },
      checkEnableDelete() {
        if (this.$store.getters.modules.includes(',5.13')) {
          this.enableDelete = true
        }
      },
      showMessageDialog(data) {
        this.receivedMessgae = data.receivedRemarks
        this.goodsReceivedStatus = data.goodsReceivedStatus
        this.id = data.id
        this.receivedMessageDialog = true
      },
      showTransportationDialog(data) {
        this.transportationDetails = data.transportation
        this.transportationDialog = true
      },
      cancelMessage() {
        this.receivedMessgae = ''
        this.receivedMessageDialog = false
      },
      closelTransportation() {
        this.transportationDialog = false
      },
      totalBalance() {
        this.totalSubAmount = 0.0
        this.totalNonTaxableAmount = 0.0
        this.totalTaxableAmount = 0.0
        this.totalVatAmount = 0.0
        this.totalSumBillAmount = 0.0
        this.totalDiscountAmount = 0.0
        for (let sale of this.salesUnreceivedLists) {
          this.totalSumBillAmount += sale.totalBillAmount
        }
      },
      async editSalesInvoice(data) {
        this.$router.push({ name: 'Sales Invoice', params: { salesInvoice: data } })
      },
      async deleteReport(value) {
        if (value.trim() === '') {
          this.$toast.add({ severity: 'success', summary: '', detail: 'Delete reason cannot be empty!', life: 10000 })
          this.dialogShow = true
          return
        }
        let deleteRe = {
          inventoryOutHeaderId: this.accountId,
          deleteReason: value
        }
        let resp = await this.$store.dispatch('deleteSalesInvoice', deleteRe)
        if (resp.status === 'SUCCESS') {
          this.$toast.add({ severity: 'success', summary: '', detail: resp.message, life: 10000 })
        } else {
          this.$toast.add({ severity: 'error', summary: '', detail: resp.message, life: 10000 })
        }
        this.dialogShow = false
      },
      setEnglishDate() {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      },
      checkEnglish() {
        if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
          this.englishDateEnabled = true
          return
        } else {
          this.englishDateEnabled = false
          return
        }
      },
      reset() {
        if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
          this.setNepaliDate()
        } else {
          this.setEnglishDate()
        }
      },
      cancel(data) {
        this.dialogShow = false
      },
      openDialog(id) {
        this.dialogShow = true
        this.accountId = id
      }
    },
    components: {
      DatePicker,
      DataTable,
      Column,
      Dialog,
      InputText,
      Button,
      InputMask,
      Dropdown,
      Dialogs,
      Textarea
    }
  }
  </script>
  <style scoped src="@../../../static/css/purchase.css"></style>
  



// WEBPACK FOOTER //
// salesGoodsUnReceivedReport.vue?5e13a618